import { gql } from "@apollo/client";

export const UPDATE_DENY_STATUS = gql`
  mutation UpdateDenyStatus($updateDenyStatusInput: UpdateDenyStatusInput) {
    updateDenyStatus(updateDenyStatusInput: $updateDenyStatusInput)
  }
`;
